export enum CharacterAnimations {
  ENCOURAGE = 'encourage',
  IDLE_1 = 'idle1',
  IDLE_2 = 'idle2',
  IDLE_3 = 'idle3',
  WIN = 'win',
  LOSE = 'loss',
  SLEEPY = 'idle4Loop',
  WAKE_UP = 'idle4Out',
  YAWN_TO_SLEEPY = 'idle4In',
}

export const CHARACTER_ANIMATION_JSON = '/animation/bunnyAnim.json';
export const CHARACTER_ANIMATION_ATLAS = '/animation/bunnyAnim.atlas';
